import React from "react";
import { useForm } from "react-hook-form";
// import { mandatoryConditions } from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/data";
import { Table } from "react-bootstrap";
import InputWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/components/Button";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

export const SelectMandatoryConditions2 = ({ setMandatoryCondition, tenantId, setCurrentTab }) => {
  const { control, watch, handleSubmit } = useForm();
  const Modal = useModal();
  const { data: { BPA: { MandatoryConditions: mandatoryConditions } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    ["MandatoryConditions"]
  );
  console.log("loggingFrom2Mandatory", mandatoryConditions);

  const onSubmit = (payload) => {
    payload = Object.fromEntries(Object.entries(payload).filter(([key, value]) => value === true));
    setMandatoryCondition(payload);
    Modal("Conditions saved", "Mandatory conditions details are saved.", "success");
    setCurrentTab(0);
    console.log("payloadFromMandatory", payload);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Table bordered hover responsive className="formHeaderContainer">
        <thead style={{ backgroundColor: "rgb(21, 124, 179)", color: "white" }}>
          <tr>
            <th style={{ minWidth: "fit-content", padding: "4px" }}>Conditions</th>
            <th style={{ minWidth: "fit-content", padding: "4px" }}>Select if applicable</th>
          </tr>
        </thead>
        <tbody>
          {mandatoryConditions?.map((item, index) => (
            <tr key={index}>
              <td style={{ padding: "4px 4px 4px 8px" }}>{item.label}</td>

              <td style={{ textAlign: "center", padding: "4px" }}>
                <InputWrapper type="checkbox" name={item.key} control={control} containerStyles={{ padding: "0px", margin: "0" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="footerContainer2">
        <div className="buttonWrapper">
          <ButtonWrapper
            variant="contained"
            color="success"
            size="medium"
            label="Save"
            type="submit"
            sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
          />
        </div>
      </div>
    </form>
  );
};
